import { Clock, FileBarChart, LayoutDashboard } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import {
  CAPABILITY_TA_BULK_CLOCK_APPROVE,
  CAPABILITY_TA_CONFIGURE_SITES,
  CAPABILITY_TA_OVERRIDE_CLOCK,
  CAPABILITY_TA_VIEW_COVERAGE,
  CAPABILITY_TA_VIEW_EXCEPTIONS,
  FEATURE_TIME_AND_ATTENDANCE,
} from "../../utils/UserAccessControlUtils";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";
import ShiftSitesOverviewPage from "./pages/ShiftSitesOverviewPage";
import ShiftSiteDetailPage from "./pages/ShiftSiteDetailPage";
import ShiftSiteAttendancePage from "./pages/ShiftSiteAttendancePage";
import BatchClockPage from "./pages/BatchClockPage";
import EmployeeOverridePage from "./pages/EmployeeOverridePage";
import ExceptionsPage from "./pages/ExceptionsPage";
import ShiftSiteConfigurationPage from "./pages/ShiftSiteConfigurationPage";
import ShiftSiteConfigPage from "./pages/ShiftSiteConfigPage";
import ReportsPage from "../reports/pages/ReportsPage";
import SiteConfigurationRouter from "../site-configuration/SiteConfigurationRouter";

const TimeAttendanceRouter: NavigationLinkProps[] = [
  {
    id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-parent",
    title: "Time & Attendance",
    description: "Time and attendance",
    path: "#",
    auth: true,
    sidebar: true,
    icon: Clock,
    requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
    requiredPermissions: ["ANY"],
    children: [
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-overview",
        title: "Overview",
        description: "Time and attendance dashboard",
        path: "/time-attendance",
        auth: true,
        sidebar: true,
        icon: LayoutDashboard,
        component: ShiftSitesOverviewPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_VIEW_COVERAGE,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-reports",
        title: "Reports",
        description: "Time and attendance reports wizard",
        path: "/reports",
        auth: true,
        sidebar: true,
        icon: FileBarChart,
        component: ReportsPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        isFeatureFlagged: true,
        requiredFeatureFlag: FeatureFlags.REPORTS_AGENT_UI,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-exceptions",
        title: "Attendance Exceptions",
        description: "View attendance exceptions",
        path: "/time-attendance/exceptions",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: ExceptionsPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_VIEW_EXCEPTIONS,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-site-detail",
        title: "Site Attendance",
        description: "Site-level attendance with roster groups",
        path: "/time-attendance/shift-site/:shiftSiteId",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: ShiftSiteAttendancePage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_VIEW_COVERAGE,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-shift-site-config",
        title: "Shift Site Configuration",
        description: "Configure shift site geofence and defaults",
        path: "/time-attendance/shift-site/:shiftSiteId/config",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: ShiftSiteConfigPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_CONFIGURE_SITES,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-location",
        title: "Location Detail",
        description: "Location attendance detail",
        path: "/time-attendance/:locationId",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: ShiftSiteDetailPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_VIEW_COVERAGE,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-batch-clock",
        title: "Batch Clock In/Out",
        description: "Batch clock in/out employees",
        path: "/time-attendance/:locationId/clock",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: BatchClockPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_BULK_CLOCK_APPROVE,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-site-config",
        title: "Site Configuration",
        description: "Configure site location and shift rules",
        path: "/time-attendance/:locationId/config",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: ShiftSiteConfigurationPage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_CONFIGURE_SITES,
        mobileAvailable: true,
      },
      {
        id: "a1b2c3d4-e5f6-7890-abcd-time-attendance-employee-override",
        title: "Employee Override",
        description: "Individual employee clock override",
        path: "/time-attendance/:locationId/employee/:employeeId",
        auth: true,
        sidebar: false,
        secondarySidebar: false,
        component: EmployeeOverridePage,
        requiredFeature: FEATURE_TIME_AND_ATTENDANCE,
        requiredPermissions: ["ANY"],
        requiredCapability: CAPABILITY_TA_OVERRIDE_CLOCK,
        mobileAvailable: true,
      },
      ...SiteConfigurationRouter,
    ],
  },
];

export default TimeAttendanceRouter;
